import KeywordListFloatingBtnMobile from './KeywordListFloatingBtnMobile.vue';

export default KeywordListFloatingBtnMobile;
